<template>
  <div>
    <div class="box border border-t-0 mb-8">
      <div class="row">
        <!-- Class-Based Coverage -->
        <div class="col-12 col-md-6">
          <div class="md:pr-8">
            <h3 class="h3 mb-8">{{classHeading}}</h3>
            <ClassRange class="mt-8"
              :data="classRange"
              :min-value="expectedPrice.classIII.avg"
              :max-value="expectedPrice.classIV.avg"
              :initial="classWeightingFactor"
            />
            <SingleSlider
              class="mt-4"
              label="Protection Factor"
              :data="protectionFactorClass"
              :disabled="classDisabled"
              type="value"
              @change="updateProtectionFactorClass"
            />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="flex-grow">
            <h3 class="h3 mb-8">Coverage Level</h3>
            <CoverageSlider
              class="mt-4"
              label="Protection Factor"
              type="value"
              :data="coverageLevel"
              :disabled="loading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ClassRange from '../components/ClassRange.vue';
import CoverageSlider from '../components/CoverageSlider.vue';
import SingleSlider from '../components/SingleSlider.vue';

const protectionFactorOptions = {
  minLabel: '1x',
  minValue: 1.00,
  maxLabel: '1.5x',
  maxValue: 1.50,
  price: null,
  displayValueType: 'number',
  valueType: 'number',
  valueDecimals: 2,
};

export default {
  name: 'ClassView',
  components: {
    ClassRange,
    CoverageSlider,
    SingleSlider,
  },

  data() {
    return {
      classHeading: 'Class-Based Coverage',
      componentHeading: 'Component-Based Coverage',
      classRange: {
        minLabel: 'Class III',
        maxLabel: 'Class IV',
      },
      protein: {
        prop: 'declaredProteinTest',
        key: null,
        componentName: 'protein',
        model: 'percent',
        type: 'value',
        minLabel: '$2.75',
        minValue: 2.75,
        minPrice: 2.25,
        maxLabel: '$4.50',
        maxValue: 4,
        maxPrice: 4.5,
        value: 2.75,
        price: 2.25,
        displayValueType: 'percent',
        valueDecimals: 2,
      },
      butterFat: {
        prop: 'declaredButterfatTest',
        key: null,
        componentName: 'butterFat',
        model: 'percent',
        type: 'value',
        minLabel: 'Butterfat %',
        minValue: 3.25,
        minPrice: 2.25,
        maxLabel: '$5.50',
        maxValue: 5,
        maxPrice: 4.5,
        value: 2.25,
        price: 2.25,
        displayValueType: 'percent',
        valueDecimals: 2,
      },

      coverageLevel: {
        prop: 'coverageLevel',
        key: null,
        minLabel: '80',
        minValue: 80,
        maxLabel: '95',
        maxValue: 95,
        value: '95',
        price: null,
        displayValueType: 'percent',
        valueType: 'percent',
        valueDecimals: 0,
      },
    };
  },

  computed: {
    ...mapState([
      'milkProduction',
      'classIns',
      'compIns',
      'queryLoaded',
      'expectedPrice',
      'availability',
      'quarter',
      'loading',
      'classWeightingFactor',
      'compWeightingFactor',
    ]),
    ...mapGetters(['classDisabled']),
    protectionFactorComponent() {
      return {
        prop: 'compIns',
        key: 'protectionFactor',
        value: this.compIns.protectionFactor,
        ...protectionFactorOptions,
      };
    },
    protectionFactorClass() {
      return {
        prop: 'classIns',
        key: 'protectionFactor',
        value: this.classIns.protectionFactor,
        ...protectionFactorOptions,
      };
    },
    defaultCompSliderValue() {
      if (!this.availability.componentClassIII) return '100';
      if (!this.availability.componentClassIV) return '0';
      return '50';
    },
  },

  methods: {
    ...mapMutations([
      'updateProtectionFactorClass',
      'updateProtectionFactorComponent',
      'updateProteinTest',
      'updateButterfatTest',
      'updateInsuranceBlend',
    ]),
  },

  mounted() {
    this.updateInsuranceBlend(0);
  },
};

</script>
